import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { WorkerRegistroFattureAcquistoModalComponent } from './worker-registro-fatture-acquisto-modal';

export const WorkerRegistroFattureAcquistoModalModule: string = ng
    .module('worker-registro-fatture-acquisto-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerRegistroFattureAcquistoModalComponent', WorkerRegistroFattureAcquistoModalComponent)
    .name;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-registro-fatture-acquisto-modal/worker-registro-fatture-acquisto-modal.module.ts